export const it = {
  passportVisa: {
  pageTitle: 'Passaporti e Visti Hajj',
  pageSubtitle: 'Gestione dei documenti di passaporti e visti per i pellegrini',
  downloadAllZip: 'Scarica tutto come file ZIP',
  creatingZip: 'Creazione del file ZIP in corso...',
  exportStatus: 'Stato dell\'esportazione',
  exporting: 'Esportazione in corso...',
  searchPlaceholder: 'Cerca per nome, numero di passaporto, guida o organizzatore...',
  allOrganizers: 'Tutti gli organizzatori',
  allDocumentTypes: 'Tutti i tipi di documenti',
  passportOnly: 'Solo passaporto',
  visaOnly: 'Solo visto',
  allStatuses: 'Tutti gli stati',
  complete: 'Completo',
  missing: 'Mancante',
  activeFilters: 'Filtri attivi:',
  search: 'Cerca',
  organizer: 'Organizzatore',
  status: 'Stato',
  documentType: 'Tipo di documento',
  loadingStatuses: 'Caricamento degli stati dei documenti...',
  documentsByCountry: 'Documenti per paese',
  documentsByOrganizer: 'Documenti per organizzatore',
  noDataAvailable: 'Nessun dato disponibile',
  country: 'Paese',
  total: 'Totale',
  pilgrim: 'Pellegrino',
  guideAndOrganizer: 'Guida e organizzatore',
  document: 'Documento',
  type: 'Tipo',
  actions: 'Azioni',
  uploaded: 'Caricato',
  notUploaded: 'Non caricato',
  viewDocument: 'Visualizza documento',
  upload: 'Carica',
  view: 'Visualizza',
  noDocumentsMatch: 'Nessun documento corrisponde ai criteri di ricerca',
  noDocumentsAvailable: 'Nessun documento disponibile',
  showing: 'Mostrando',
  of: 'di',
  documents: 'documenti',
  loadingPilgrimData: 'Caricamento dei dati dei pellegrini...',
  previous: 'Precedente',
  next: 'Successivo',
  page: 'Pagina',
  exportSuccess: 'Esportazione completata con successo',
  exportError: 'Errore nell\'esportazione dei dati',
  downloadSuccess: 'Documenti scaricati con successo',
  downloadError: 'Errore nella creazione del file ZIP',
  uploadSuccess: (type: string) => `Caricamento di ${type} completato con successo`,
  uploadError: 'Errore nel caricamento del documento',
  failedToLoadStatuses: 'Errore nel caricamento degli stati dei documenti',
  deleteSuccess: 'Documento eliminato con successo',
  deleteError: 'Errore nell\'eliminazione del documento'
},
  accommodationChart: {
    checkInOutTitle: 'Programma di check-in e check-out',
    loadData: 'Carica dati',
    export: 'Esporta dati',
    exportSuccess: 'Dati esportati con successo',
    exportError: 'Errore durante l\'esportazione dei dati',
    loading: 'Caricamento in corso...',
    noData: 'Nessun dato disponibile',
    clickToLoad: 'Clicca per caricare i dati e visualizzare le statistiche',
    loadError: 'Errore durante il caricamento dei dati',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    myCheckIn: 'Miei check-in',
    myCheckOut: 'Miei check-out',
    accommodated: 'Ospitati',
    myAccommodated: 'Miei ospitati',
    totalCheckIns: 'Totale check-in',
    totalCheckOuts: 'Totale check-out',
    totalAccommodated: 'Totale ospitati',
    myTotalAccommodated: 'Totale miei ospitati',
    peakOn: 'Picco il',
    yours: 'tuoi'
  },
  roomTypesChart: {
    all: 'Tutti i tipi di camera',
    double: 'Doppia',
    triple: 'Tripla',
    quadruple: 'Quadrupla'
  },
  bulkLinkStatus: {
    title: 'Risultati Collegamento Massivo',
    backToGuide: 'Torna alla Pagina della Guida',
    export: 'Esporta Risultati',
    processing: 'Elaborazione del file...',
    rowsProcessed: 'Righe elaborate',
    totalProcessed: 'Totale elaborato',
    successful: 'Riuscito',
    failed: 'Fallito',
    successRate: 'Tasso di successo',
    identifier: 'Identificatore',
    pilgrimName: 'Nome del Pellegrino',
    guide: 'Guida',
    status: 'Stato',
    errors: 'Errori',
    statusSuccess: 'Successo',
    statusError: 'Errore',
    statusProcessing: 'Elaborazione in corso',
  },
  bulkLink: {
    validation: {
      invalidIdentifierType: 'Tipo di identificatore non valido',
      identifierRequired: 'Identificatore richiesto',
      guideRequired: 'Nome della guida richiesto',
      pilgrimNotFound: 'Pellegrino non trovato',
      processingInProgress: 'Elaborazione del pellegrino in corso',
      duplicatePilgrim: 'Il pellegrino appare più di una volta nel file',
      guideNotFound: 'Guida non trovata',
    },
  },
  verificationWizardPage: {
    errors: {
      checkVerification: 'Errore nel verificare lo stato della verifica',
      userNotFound: "Informazioni sull'utente non trovate",
      verificationFailed: 'Errore nel completare la verifica',
    },
    success: {
      verificationSubmitted: 'Verifica inviata con successo',
    },
  },
  wizardProgress: {
    steps: {
      terms: 'Termini',
      info: 'Informazioni',
      contract: 'Contratto',
      bank: 'Informazioni bancarie',
    },
  },
  bankStep: {
    headers: {
      bankInformation: 'Informazioni bancarie',
    },
    labels: {
      bankName: 'Nome della banca',
      accountNumber: 'Numero di conto',
      swiftCode: 'Codice SWIFT / BIC',
      bankBranch: 'Filiale della banca',
      ifscCode: 'Codice RTGS / NEFT / IFSC',
    },
    placeholders: {
      bankName: 'Inserisci il nome della banca',
      accountNumber: 'Inserisci il numero del tuo conto',
      swiftCode: 'Esempio: BOFAUS3N',
      bankBranch: 'Inserisci il nome della filiale',
      ifscCode: 'Esempio: ABCD0123456',
    },
    errors: {
      bankNameRequired: 'Nome della banca richiesto',
      accountNumberInvalid: 'Formato numero di conto non valido (10-20 cifre)',
      swiftCodeInvalid: 'Formato codice SWIFT / BIC non valido',
      bankBranchRequired: 'Nome della filiale richiesto',
      ifscCodeInvalid: 'Formato codice IFSC non valido',
    },
    buttons: {
      back: 'Indietro',
      submit: 'Invia',
    },
    validationMessages: {
      requiredField: 'Questo campo è obbligatorio',
      validAccountNumber:
        'Il numero del conto deve essere composto da 10 a 20 cifre',
      validSwiftCode:
        'Il codice SWIFT deve essere composto da 6 lettere seguite da 2 o 3 numeri/lettere',
    },
    success: {
      formSubmitted: 'Dati inviati con successo',
    },
  },
  contractStep: {
    headers: {
      contractReview: 'Revisione del contratto',
      contractName: 'Accordo per i servizi di marketing',
    },
    subHeaders: {
      reviewMessage: 'Si prega di rivedere il contratto prima di firmarlo',
    },
    labels: {
      digitalSignature: 'Firma digitale (scrivi il tuo nome completo)',
    },
    placeholders: {
      signature: 'Scrivi il tuo nome completo come firma',
    },
    buttons: {
      viewContract: 'Visualizza modello del contratto',
      generateContract: 'Genera contratto',
      generatingContract: 'Generazione contratto in corso...',
      downloadContract: 'Scarica contratto firmato',
      next: 'Avanti',
      submit: 'Invia',
      back: 'Indietro',
    },
    success: {
      contractGenerated: 'Contratto generato con successo',
    },
    errors: {
      noSignature: 'Si prega di fornire la tua firma digitale',
      contractGeneration: 'Errore nella generazione del contratto, riprova',
    },
  },
  infoStep: {
    title: 'Informazioni personali',
    labels: {
      fullName: 'Nome completo (come nel passaporto)',
      passportNumber: 'Numero del passaporto',
      passportIssuanceDate: 'Data di rilascio del passaporto',
      nationality: 'Nazionalità',
      country: 'Paese di residenza',
      mobileNumber: 'Numero di cellulare',
      email: 'Email',
      agent: "Nome dell'agente/azienda",
    },
    placeholders: {
      fullName: 'Inserisci il nome completo',
      passportNumber: 'Inserisci il numero del passaporto',
      nationality: 'Inserisci la nazionalità',
      country: 'Inserisci il paese di residenza',
      mobileNumber: '+1234567890',
      email: 'esempio@dominio.com',
      agent: "Inserisci il nome dell'azienda",
    },
    errors: {
      fullName: 'Il nome completo deve essere di almeno 3 lettere',
      passportNumber: 'Formato numero passaporto non valido',
      issuanceDateRequired: 'Data di rilascio richiesta',
      invalidDate: 'Formato data non valido',
      futureDate: 'La data di rilascio non può essere nel futuro',
      oldDate: 'La data di rilascio non può essere precedente a 10 anni',
      nationalityRequired: 'Nazionalità richiesta',
      countryRequired: 'Paese di residenza richiesto',
      invalidMobile: 'Formato numero di cellulare non valido',
      invalidEmail: 'Formato email non valido',
      agentRequired: "Nome dell'agente/azienda richiesto",
    },
    buttons: {
      back: 'Indietro',
      next: 'Avanti',
    },
  },
  terms: {
    title: 'Dichiarazione e impegno',
    acknowledgment: 'Io sottoscritto, dichiaro e mi impegno a quanto segue:',
    compliance:
      "Conformità a tutti i termini dell'Accordo sui Servizi di Marketing firmato con ithraa alkhair per i Servizi di Hajj.",
    provideServices: 'Fornire servizi di marketing come segue:',
    promotePackages:
      'Promuovere le caratteristiche dei pacchetti e dei servizi di ithraa alkhair tramite mezzi digitali, social media, eventi e fiere.',
    encouragePilgrims:
      'Incoraggiare i pellegrini a registrarsi sulla piattaforma Nusuk e monitorare da vicino il processo di registrazione.',
    submitList:
      "Fornire un elenco dei pellegrini registrati sulla piattaforma Nusuk prima dell'inizio della fase di acquisto dei pacchetti.",
    adhereTo: 'Conformarsi a quanto segue:',
    uploadData: 'Caricare i dati dei pellegrini entro il termine stabilito.',
    ensureAccuracy:
      "Garantire l'accuratezza dei dati ed evitare duplicati o corrispondenze con i dati di altri guide.",
    clearMessages:
      'Usare messaggi di marketing chiari che siano in linea con i valori religiosi e culturali.',
    noComplaints:
      'Garantire che non ci siano reclami o problemi legati ai servizi forniti.',
    legalResponsibility:
      'Assumersi la piena responsabilità legale e finanziaria in caso di violazione degli impegni sopra descritti.',
    agreeTerms: 'Accetto i termini e le condizioni sopra indicate',
    next: 'Avanti',
  },
  verification: {
    detailsTitle: 'Dettagli della verifica',
    created: 'Creato',
    lastUpdated: 'Ultimo aggiornamento',
    rejectionReason: 'Motivo del rifiuto',
    viewContract: 'Visualizza contratto',
    delete: 'Elimina',
    deleteSuccess: 'Verifica eliminata con successo',
    deleteError: "Errore nell'eliminazione della verifica",
    userType: 'Tipo di utente',
    createdAt: 'Creato il',
    personalInfo: 'Informazioni personali',
    bankInfo: 'Informazioni bancarie',
    digitalSignature: 'Firma digitale',
    bankName: 'Nome della banca',
    accountNumber: 'Numero di conto',
    swiftCode: 'Codice SWIFT',
    bankBranch: 'Filiale della banca',
    ifscCode: 'Codice IFSC',
    noBankInfo: 'Nessuna informazione bancaria fornita',
    bankInfoUpdated: 'Informazioni bancarie aggiornate con successo',
    bankInfoError: 'Errore durante l\'aggiornamento delle informazioni bancarie',
    viewSignedContract: 'Visualizza contratto firmato',
  },
  verificationApproval: {
    statuses: {
      approved: 'Approvato',
      rejected: 'Rifiutato',
      pending: 'In sospeso',
    },
    userTypes: {
      guide: 'Guida',
      organizer: 'Organizzatore',
    },
    createdAt: 'Creato il',
    buttons: {
      viewContract: 'Visualizza contratto',
      delete: 'Eliminare',
      approve: 'Approva',
      reject: 'Rifiuta',
      export: 'Esporta',
      downloadContracts: 'Scarica contratti',
      cancel: 'Annulla',
    },
    bankInfo: {
      title: 'Informazioni bancarie',
      bankName: 'Nome della banca',
      accountNumber: 'Numero di conto',
      swiftCode: 'Codice SWIFT',
      bankBranch: 'Filiale della banca',
      ifscCode: 'Codice IFSC',
    },
    filters: {
      searchPlaceholder: 'Cerca...',
      allStatuses: 'Tutti gli stati',
      pending: 'In sospeso',
      approved: 'Approvato',
      rejected: 'Rifiutato',
      allTypes: 'Tutti i tipi',
      guides: 'Guide',
      organizers: 'Organizzatori',
      activeFilters: 'Filtri attivi:',
      search: 'Ricerca',
      status: 'Stato',
      type: 'Tipo',
    },
    dialog: {
      approveTitle: 'Approva la verifica',
      rejectTitle: 'Rifiuta la verifica',
      deleteTitle: 'Elimina la verifica',
      approveMessage: 'Sei sicuro di voler approvare questa verifica?',
      rejectMessage: 'Sei sicuro di voler rifiutare questa verifica?',
      rejectionReasonLabel: 'Motivo del rifiuto',
      deleteMessage:
        'Sei sicuro di voler eliminare questa verifica per {name}? Questa azione non può essere annullata.',
    },
  },
  pilgrimSelector: {
    searchPlaceholder: 'Cerca per nome, passaporto o paese...',
    passport: 'Passaporto',
    arrivalDate: 'Data di arrivo',
    noResults: 'Nessun pellegrino corrispondente trovato',
    startSearch: 'Inizia la ricerca del pellegrino...',
  },
  header: {
    refresh: 'Aggiorna',
    refreshing: 'Aggiornamento in corso...',
    refreshSuccess: 'Dati aggiornati con successo',
    refreshError: "Errore durante l'aggiornamento dei dati",
  },
  verificationPage: {
    verifying: 'Verifica in corso...',
    verifyNow: 'Verifica ora',
    clickButton:
      'Clicca sul pulsante per verificare la connessione tra i pellegrini, i pacchetti e i voli',
  },
  team: {
    title: 'Team',
    addMember: 'Aggiungi membro',
  },
  evidenceViewModal: {
    title: 'Prova del guida',
    noEvidence: 'Nessuna prova fornita',
    textEvidence: 'Testo della prova',
    imageEvidence: 'Immagine della prova',
    submittedAt: 'Data di invio',
    updatedAt: 'Ultimo aggiornamento',
  },
  disputeCard: {
    selectGuide: 'Selezionare una guida',
    resolveSuccess: 'Disputa risolta con successo',
    resolveError: 'Errore nella risoluzione della disputa',
    emailSubject:
      'Importante: Verifica richiesta per la guida - Supporto tecnico da Athra Al-Khairat',
    emailBodyPart1: 'Caro/a',
    emailBodyPart2:
      'Ci stiamo mettendo in contatto con te dal supporto tecnico di Athra Al-Khairat riguardo alle tue disposizioni per il pellegrinaggio.',
    emailBodyPart3:
      'Abbiamo ricevuto informazioni contrastanti sulla tua guida designata. Secondo i nostri registri, entrambe le parti dichiarano di essere la tua guida ufficiale.',
    emailBodyPart4:
      'Puoi confermare chi è la tua guida designata? Questa informazione è importante per garantire che il servizio venga fornito correttamente durante il pellegrinaggio.',
    emailBodyPart5: 'Cordiali saluti,',
    emailBodyPart6: 'Il team di supporto tecnico di Athra Al-Khairat',
    emailNotAvailable: 'Email non disponibile',
    whatsAppMessage1: 'Caro/a',
    whatsAppMessage2:
      'Il team di supporto tecnico di Athra Al-Khairat sta cercando di mettersi in contatto con te riguardo le tue disposizioni per il pellegrinaggio.',
    whatsAppMessage3:
      'Abbiamo ricevuto informazioni contrastanti sulla tua guida designata. Secondo i nostri registri, entrambe le parti dichiarano di essere la tua guida ufficiale.',
    whatsAppMessage4:
      'Puoi confermare chi è la tua guida designata? Questa informazione è importante per garantire che il servizio venga fornito correttamente durante il pellegrinaggio.',
    whatsAppMessage5: 'Cordiali saluti,',
    whatsAppMessage6: 'Il team di supporto tecnico di Athra Al-Khairat',
    phoneNotAvailable: 'Numero di telefono non disponibile',
    sendEmail: 'Invia email',
    sendWhatsApp: 'Invia tramite WhatsApp',
    countryNotAvailable: 'Paese non disponibile',
    passport: 'Passaporto',
    viewEvidence: 'Visualizza prova',
    resolveDispute: 'Risolvi disputa',
    requestDate: 'Data della richiesta',
  },
  disputesList: {
    noDisputes: 'Nessuna disputa corrispondente ai filtri selezionati',
  },
  disputesPage: {
    header: 'Dispute',
    description:
      'Gestisci le dispute tra le guide riguardo alla proprietà dei pellegrini',
  },
  linkingStats: {
    totalPilgrims: 'Pellegrini totali',
    countries: 'Numero di paesi',
    approved: 'Collegato',
    pending: 'In attesa',
    rejected: 'Rifiutato',
  },
  linkingTableRow: {
    status: {
      approved: 'Collegato',
      rejected: 'Rifiutato',
      pending: 'In attesa',
      waitingIdentification: 'In attesa di identificazione',
    },
    labels: {
      passport: 'Passaporto',
    },
  },
  linkingStatusPage: {
    header: 'Stato del collegamento',
    description: 'Monitora lo stato del collegamento tra guide e pellegrini',
  },
  verificationHeader: {
    header: 'Verifica collegamento',
    description:
      'Verifica il collegamento dei dati tra pellegrini, pacchetti e voli',
  },
  flightsPage: {
    header: 'Voli',
    downloadTemplate: 'Esempio per il caricamento',
    addFlights: 'Aggiungi voli',
    deleteAll: 'Elimina tutti i voli',
    uploadError: 'Errore durante il caricamento dei dati',
    deleteSuccess: 'Tutti i voli sono stati eliminati con successo',
    deleteError: "Errore durante l'eliminazione dei voli",
    deleteAllTitle: 'Elimina tutti i voli',
    deleteAllMessage:
      'Sei sicuro di voler eliminare tutti i voli? Questa azione non può essere annullata.',
    confirmDelete: 'Elimina tutti',
    cancel: 'Annulla',
  },
  packagesPage: {
    header: 'Pacchetti del pellegrinaggio',
    downloadTemplate: 'Esempio per il caricamento',
    addPackages: 'Aggiungi pacchetti',
    deleteAll: 'Elimina tutti i pacchetti',
    uploadError: 'Errore durante il caricamento dei dati',
    deleteSuccess: 'Tutti i pacchetti sono stati eliminati con successo',
    deleteError: "Errore durante l'eliminazione dei pacchetti",
    deleteAllTitle: 'Elimina tutti i pacchetti',
    deleteAllMessage:
      'Sei sicuro di voler eliminare tutti i pacchetti? Questa azione non può essere annullata.',
    confirmDelete: 'Elimina tutti',
    cancel: 'Annulla',
  },
  pilgrimsPage: {
    header: 'Informazioni sui pellegrini',
    downloadTemplate: 'Esempio per il caricamento',
    addPilgrims: 'Aggiungi pellegrini',
    deleteAll: 'Elimina tutti i pellegrini',
    uploadError: 'Errore durante il caricamento dei dati',
    deleteSuccess: 'Tutti i pellegrini sono stati eliminati con successo',
    deleteError: "Errore durante l'eliminazione dei pellegrini",
    deleteAllTitle: 'Elimina tutti i pellegrini',
    deleteAllMessage:
      'Sei sicuro di voler eliminare tutti i pellegrini? Questa azione non può essere annullata.',
    confirmDelete: 'Elimina tutti',
    cancel: 'Annulla',
  },
  adminDashboard: {
    morningGreeting: 'Buongiorno',
    afternoonGreeting: 'Buon pomeriggio',
    eveningGreeting: 'Buona sera',
    defaultUserName: 'Amministratore di sistema',
    welcomeMessage:
      'Benvenuto nel sistema di gestione dei pacchetti per il pellegrinaggio integrato',
    makkah: 'La Mecca',
    madinah: 'Medina',
    mina: 'Mina',
    holyCity: 'La città santa',
    prophetMosque: 'La Moschea del Profeta',
    pilgrimsCamp: 'Accampamenti dei pellegrini',
    managePilgrims: 'Gestisci pellegrini',
    movementSchedule: 'Programma dei movimenti',
    flights: 'Voli',
    accommodation: 'Alloggio',
  },
  organizerFinance: {
    importantNotice: 'Avviso Importante',
    lastUpdated: 'Ultimo aggiornamento',
    disclaimerText: 'Tutti gli importi e i pagamenti visualizzati sono soggetti a modifiche senza alcuna responsabilità legale o preavviso. Questa dichiarazione non è definitiva e non rappresenta un obbligo finanziario da parte di Ithraa Al-Khair.',
    title: 'Finanza degli Organizzatori',
    subtitle:
      'Gestisci e monitora i pagamenti degli organizzatori in base alla proprietà dei pellegrini',
    totalPilgrims: 'Totale Pellegrini',
    matchingPilgrims: 'Pellegrini Corrispondenti',
    mismatchedPilgrims: 'Pellegrini Non Corrispondenti',
    totalAmount: 'Importo Totale',
    bonusAmount: 'Importo del Bonus',
    savedAmount: 'Importo Risparmiato',
    pilgrimName: 'Nome del Pellegrino',
    passportNumber: 'Numero di Passaporto',
    assignedGuide: 'Guida Assegnata',
    owner: 'Proprietario',
    paymentType: 'Tipo di Pagamento',
    amount: 'Importo',
    status: 'Stato',
    matching: 'Corrispondente',
    mismatched: 'Non Corrispondente',
    fullPayment: 'Pagamento Completo',
    guidancePayment: 'Pagamento di Guida',
    marketingPayment: 'Pagamento Marketing',
    summary: 'Riepilogo',
    baseAmount: 'Importo Base',
    exportReport: 'Esporta Report',
    financialStats: {
      totalAmount: 'Importo Totale',
      pilgrimsDistribution: 'Distribuzione dei Pellegrini',
      savedAmount: 'Importo Risparmiato',
      includesBonus: 'Include {{bonusAmount}} SAR di bonus',
    },
    tableHeaders: {
      pilgrim: 'Pellegrino',
      passport: 'Passaporto',
      guide: 'Guida',
      owner: 'Proprietario',
      paymentType: 'Tipo di Pagamento',
      amount: 'Importo (SAR)',
    },
  },
  common: {
    loading: 'Caricamento...',
    error: 'Impossibile caricare i dati richiesti',
  },
  pilgrimOwnership: {
    title: 'Proprietà dei Pellegrini',
    subtitle: 'Gestisci e determina la proprietà reale dei pellegrini',
  },
  filters: {
    searchPlaceholder: 'Cerca per nome o numero di passaporto...',
    allCountries: 'Tutti i Paesi',
    allGenders: 'Tutti i Generi',
    male: 'Maschio',
    female: 'Femmina',
    activeFilters: 'Filtri Attivi:',
    searchLabel: 'Cerca:',
    countryLabel: 'Paese:',
    genderLabel: 'Genere:',
  },
  tableHeaders: {
    pilgrim: 'Pellegrino',
    assignedGuide: 'Guida Assegnata',
    realGuide: 'Guida Nusuk',
    ownership: 'Proprietà del Pellegrino',
    compatibility: 'Compatibilità',
    passport: 'Passaporto:',
    noGuide: 'Nessuno',
    selectRealGuide: 'Seleziona Guida Nusuk...',
    selectOwner: 'Seleziona Proprietario...',
  },
  toasts: {
    realGuideUpdated: 'Guida Nusuk aggiornata con successo',
    realGuideUpdateFailed: 'Aggiornamento della guida Nusuk fallito',
    ownershipUpdated: 'Proprietà del pellegrino aggiornata con successo',
    ownershipUpdateFailed:
      'Aggiornamento della proprietà del pellegrino fallito',
  },
  compatibility: {
    match: 'Corrisponde',
    mismatch: 'Non Corrisponde',
  },
  pilgrimGuideStore: {
    errors: {
      pilgrimNotFound:
        'Nessun pellegrino trovato con questo numero di passaporto',
      linkFailed: 'Impossibile collegare il pellegrino alla guida',
      deleteFailed: 'Impossibile eliminare il collegamento',
    },
    success: {
      linkSuccess: 'Pellegrino collegato alla guida con successo',
      deleteSuccess: 'Collegamento eliminato con successo',
    },
  },
  pilgrimsStore: {
    success: {
      uploadPilgrims: '{count} pellegrini aggiunti con successo',
    },
    errors: {
      uploadPilgrims: 'Impossibile aggiungere i pellegrini',
      deletePilgrim: 'Impossibile eliminare il pellegrino',
      deleteAll: 'Impossibile eliminare tutti i pellegrini',
      searchPilgrims: 'Impossibile cercare i pellegrini',
    },
  },
  addSuspensionModal: {
    title: 'Aggiungi nuova sospensione',
    labels: {
      suspensionType: 'Tipo di sospensione',
      hotel: 'Hotel',
      selectHotel: 'Seleziona hotel',
      reason: 'Motivo',
      duration: 'Durata',
      temporary: 'Temporanea',
      permanent: 'Permanente',
      expiryDate: 'Data di scadenza',
    },
    suspensionTypes: {
      linking: 'Sospensione del servizio di collegamento',
      allAccommodation: 'Sospensione di tutti gli alloggi',
      specificHotel: 'Sospensione di un hotel specifico',
      campAccommodation: "Sospensione dell'alloggio in campeggio",
    },
    buttons: {
      cancel: 'Annulla',
      addSuspension: 'Aggiungi sospensione',
      adding: 'Aggiunta in corso...',
    },
    errors: {
      allFieldsRequired: 'Tutti i campi sono obbligatori',
      expiryDateRequired: 'Seleziona una data di scadenza',
      suspensionAddFailed: 'Impossibile aggiungere la sospensione',
    },
    success: {
      suspensionAdded: 'Sospensione aggiunta con successo',
    },
  },
  addBanModal: {
    title: 'Aggiungi nuovo divieto',
    labels: {
      userType: 'Tipo di utente',
      guide: 'Guida',
      organizer: 'Organizzatore',
      selectUser: 'Seleziona',
      banType: 'Tipo di divieto',
      reason: 'Motivo',
      duration: 'Durata',
      temporary: 'Temporaneo',
      permanent: 'Permanente',
      expiryDate: 'Data di scadenza',
    },
    banTypes: {
      full: 'Divieto completo',
      accommodation: 'Divieto di alloggio',
      linking: 'Divieto di collegamento',
      camp: 'Divieto di campeggio',
    },
    buttons: {
      cancel: 'Annulla',
      addBan: 'Aggiungi divieto',
      adding: 'Aggiunta in corso...',
    },
    errors: {
      allFieldsRequired: 'Tutti i campi sono obbligatori',
      expiryDateRequired: 'Seleziona una data di scadenza',
      banAddFailed: 'Impossibile aggiungere il divieto',
    },
    success: {
      banAdded: 'Divieto aggiunto con successo',
    },
  },
  accommodation: {
    errors: {
      serviceSuspended: 'Il servizio di alloggio è attualmente sospeso',
      hotelSuspended: 'Questo hotel è attualmente sospeso',
      notAuthenticated: 'Non sei autenticato',
      notAuthorized: 'Non sei autorizzato a eseguire questa azione',
      userBanned: "Sei stato escluso dall'uso del servizio di alloggio",
      packageNotFound: 'Pacchetto non trovato per il pellegrino',
      hotelNotAssigned:
        'Questo hotel non è assegnato al pacchetto del pellegrino',
      pilgrimNotFound:
        'Nessun pellegrino trovato con questo numero di passaporto',
      noGuideLinked: 'Il pellegrino non è collegato a nessuna guida',
      noPermission: 'Non hai il permesso di eseguire questa azione',
      tableNotFound: 'Tabella di alloggio non trovata',
      roomNotFound: 'Camera non trovata',
      roomNumberExists: 'Il numero della camera esiste già',
      commentTextRequired: 'Il testo del commento è obbligatorio',
      userInfoRequired: 'Le informazioni utente sono obbligatorie',
      noComments: 'Nessun commento trovato',
      invalidRoomNumber: 'Numero della camera non valido',
      invalidRoomType: 'Tipo di camera non valido',
      excelParseError: 'Impossibile leggere il file Excel. Verifica i dati',
    },
    header: 'Alloggio negli hotel',
    description: 'Gestione degli alloggi dei pellegrini negli hotel',
    addButton: 'Aggiungi tabella di alloggio',
    noTables: 'Nessuna tabella di alloggio al momento',
  },
  campAccommodation: {
    errors: {
      serviceSuspended:
        'Il servizio di alloggio in campeggio è attualmente sospeso',
      notAuthenticated: 'Non sei autenticato',
      userBanned:
        "Sei stato escluso dall'uso del servizio di alloggio in campeggio",
      pilgrimNotFound:
        'Nessun pellegrino trovato con questo numero di passaporto',
      noGuideLinked: 'Il pellegrino non è collegato a nessuna guida',
      noPermission: 'Non hai il permesso di eseguire questa azione',
      tableNotFound: 'Tabella di alloggio non trovata',
      tentNotFound: 'Tenda non trovata',
      hallNotFound: 'Sala non trovata',
      genderMismatch:
        "Impossibile assegnare il pellegrino a questa sala a causa di un'incompatibilità di genere",
      notAuthorized: 'Non sei autorizzato a eseguire questa azione',
    },
    header: {
      title: 'Alloggio nei campi',
      subtitle: "Gestisci l'alloggio dei pellegrini nei campi di Mina e Arafat",
    },
    addTableButton: 'Aggiungi tabella di alloggio',
    stats: {
      totalCamps: 'Totale campi',
      occupiedTents: 'Tende occupate',
      totalCapacity: 'Capacità totale',
      occupancyRate: 'Tasso di occupazione',
    },
    noTablesMessage: 'Nessuna tabella di alloggio al momento',
  },
  bansManagement: {
    header: {
      title: 'Gestione dei divieti e delle sospensioni',
      subtitle: 'Gestisci i divieti degli utenti e le sospensioni dei servizi',
    },
    buttons: {
      addBan: 'Aggiungi nuovo divieto',
      addSuspension: 'Sospendi il servizio',
    },
    stats: {
      activeBans: 'Divieti attivi',
      expiredBans: 'Divieti scaduti',
      activeSuspensions: 'Sospensioni attive',
      totalActions: 'Totale azioni',
    },
    disputeBans: {
      title: 'Divieti di controversie',
      bannedFrom: 'Vietato trattare con il pellegrino',
      noBans: 'Nessun divieto di controversia trovato',
    },
    activeBans: {
      title: 'Divieti attivi',
      guide: 'Guida',
      organizer: 'Organizzatore',
      expiresOn: 'Scade il',
      permanentBan: 'Divieto permanente',
      noBans: 'Nessun divieto attivo trovato',
    },
    activeSuspensions: {
      title: 'Sospensioni attive',
      linking: 'Sospensione del servizio di collegamento',
      allAccommodation: 'Sospensione di tutti gli alloggi',
      specificHotel: 'Hotel',
      campAccommodation: "Sospensione dell'alloggio in campeggio",
      by: 'Da',
      expiresOn: 'Scade il',
      permanentSuspension: 'Sospensione permanente',
      noSuspensions: 'Nessuna sospensione attiva trovata',
    },
    confirmDialog: {
      deactivateBanTitle: 'Disattiva divieto',
      deactivateBanMessage: 'Sei sicuro di voler disattivare questo divieto?',
      deactivateSuspensionTitle: 'Disattiva sospensione',
      deactivateSuspensionMessage:
        'Sei sicuro di voler disattivare questa sospensione?',
      deleteBanTitle: 'Elimina divieto',
      deleteBanMessage:
        'Sei sicuro di voler eliminare definitivamente questo divieto?',
      deleteSuspensionTitle: 'Elimina sospensione',
      deleteSuspensionMessage:
        'Sei sicuro di voler eliminare definitivamente questa sospensione?',
      removeDisputeBanTitle: 'Rimuovi divieto di controversia',
      removeDisputeBanMessage:
        'Sei sicuro di voler rimuovere il divieto della guida',
      from: 'da',
      confirmText: 'Conferma',
      cancelText: 'Annulla',
    },
    success: {
      removeDisputeBan: 'Divieto rimosso con successo',
      deactivateBan: 'Divieto disattivato con successo',
      deactivateSuspension: 'Sospensione disattivata con successo',
      deleteBan: 'Divieto eliminato con successo',
      deleteSuspension: 'Sospensione eliminata con successo',
    },
    errors: {
      fetchDisputeBans: 'Impossibile recuperare i divieti di controversie',
      removeDisputeBan: 'Impossibile rimuovere il divieto',
      deactivateBan: 'Impossibile disattivare il divieto',
      deactivateSuspension: 'Impossibile disattivare la sospensione',
      deleteBan: 'Impossibile eliminare il divieto',
      deleteSuspension: 'Impossibile eliminare la sospensione',
    },
  },
  accommodationLogs: {
    header: 'Registro delle Attività',
    subheader: 'Monitoraggio delle attività di alloggio negli hotel',
    searchPlaceholder: 'Cerca...',
    filters: {
      allHotels: 'Tutti gli Hotel',
      allActions: 'Tutte le Azioni',
      allRoles: 'Tutti i Ruoli',
      assign: 'Assegna',
      remove: 'Rimuovi',
      admin: 'Amministratore',
      guide: 'Guida',
      organizer: 'Organizzatore',
      search: 'Cerca',
      hotel: 'Hotel',
      action: 'Azione',
      role: 'Ruolo',
    },
    activeFilters: 'Filtri Attivi:',
    logActions: {
      assign: 'Assegnato',
      remove: 'Rimosso',
    },
    logDetails: {
      pilgrimInfo: 'Informazioni Pellegrino',
      accommodationInfo: 'Informazioni Alloggio',
      room: 'Stanza',
      bed: 'Letto',
      performedBy: 'Eseguito da:',
    },
    noLogs: 'Nessun registro corrisponde ai filtri selezionati',
  },
  PilgrimGuide: {
    messages: {
      deleteSuccess: 'Il collegamento è stato eliminato con successo',
      deleteError: "Errore durante l'eliminazione del collegamento",
    },
    errors: {
      deletePermission: 'Non hai il permesso di eliminare questo collegamento',
      invalidLinkId: 'ID del collegamento non valido',
      noDispute: 'Nessuna disputa disponibile per presentare prove',
    },
    confirmDialog: {
      deleteTitle: 'Elimina collegamento',
      disputeMessage:
        "Eliminando questo collegamento, la disputa verrà chiusa e i diritti verranno assegnati all'altra guida. Sei sicuro di voler eliminare il collegamento per il pellegrino {name}?",
      defaultMessage:
        'Sei sicuro di voler eliminare il collegamento per il pellegrino {name}?',
      deleting: 'Eliminazione in corso...',
      delete: 'Elimina',
      cancel: 'Annulla',
    },
  },
  evidenceModal: {
    title: 'Presenta prova',
    textLabel: 'Testo della prova',
    textPlaceholder: 'Inserisci i dettagli della prova qui...',
    textRequiredError: 'Il testo della prova è obbligatorio',
    imageLabel: 'Immagine della prova (opzionale)',
    uploadButton: 'Carica file',
    dragAndDrop: 'Oppure trascina e rilascia',
    fileRequirements: 'PNG, JPG fino a 5MB',
    fileSizeError: 'La dimensione del file deve essere inferiore a 5MB',
    uploadError: "Errore durante il caricamento dell'immagine",
    uploadWaitError: "Attendi il completamento del caricamento dell'immagine",
    uploadingText: "Caricamento dell'immagine in corso...",
    cancelButton: 'Annulla',
    submitButton: 'Presenta prova',
    savingButton: 'Salvataggio in corso...',
    submitSuccess: 'Prova presentata con successo',
    submitError: 'Errore durante la presentazione della prova',
  },
  linkPilgrimToGuideAction: {
    banError:
      'Non puoi collegare questo pellegrino a causa di un blocco da una disputa precedente',
    alreadyLinkedError: 'Questo pellegrino è già collegato a te',
    linkError: 'Errore durante il collegamento del pellegrino alla guida',
    waitingIdentificationExists: 'Questo pellegrino è già in attesa di identificazione',
    waitingIdentificationName: 'In attesa di identificazione',
  },
  deleteLinkAction: {
    linkNotFound: 'Collegamento non trovato',
    deleteError: "Errore durante l'eliminazione del collegamento",
    hotelAccommodationError:
      "Non è possibile eliminare il pellegrino perché è ospitato nell'hotel {hotelName} stanza {roomNumber}",
    campAccommodationError:
      'Non è possibile eliminare il pellegrino perché è ospitato nel campo {campName} tenda {tentNumber} sala {hallNumber}',
  },
  activeFilters: {
    activeFiltersLabel: 'Filtri attivi:',
    searchLabel: 'Cerca:',
    statusLabel: 'Stato:',
    countryLabel: 'Paese:',
    statusApproved: 'Collegato',
    statusPending: 'In attesa',
    statusDisputed: 'In disputa',
    statusRejected: 'Rifiutato',
    statusWaitingIdentification: 'In attesa di identificazione',
  },
  resetPasswordModal: {
    title: 'Cambia password',
    newPasswordLabel: 'Nuova password',
    confirmPasswordLabel: 'Conferma password',
    cancelButton: 'Annulla',
    saveButton: 'Salva',
    savingButton: 'Salvataggio in corso...',
    passwordMismatch: 'Le password non coincidono',
    passwordLengthError: 'La password deve contenere almeno 6 caratteri',
    passwordChangeSuccess: 'Password cambiata con successo',
    passwordChangeError: 'Errore durante il cambio della password',
  },
  campAccommodationTable: {
    exportSuccess: "Dati dell'alloggio esportati con successo",
    exportError: "Errore durante l'esportazione dei dati dell'alloggio",
    deleteSuccess: "Tabella dell'alloggio eliminata con successo",
    deleteError: "Errore durante l'eliminazione della tabella dell'alloggio",
    deleteTitle: "Elimina tabella dell'alloggio",
    deleteMessage: 'Sei sicuro di voler eliminare la tabella',
    deleteButton: 'Elimina tabella',
    confirmDelete: 'Elimina',
    cancelDelete: 'Annulla',
    tents: 'Tende',
    capacity: 'Capacità',
    occupancyRate: 'Tasso di occupazione',
    occupiedTotal: 'Occupati / Totali',
    percentage: 'Percentuale',
    viewDetails: 'Visualizza dettagli',
    exportTitle: 'Scarica alloggio',
    exportButton: 'Scarica alloggio',
  },
  settingsPage: {
    headerTitle: 'Impostazioni',
    headerSubtitle: "Gestisci le impostazioni dell'account",
    changePasswordTitle: 'Cambia password',
    currentPasswordLabel: 'Password attuale',
    newPasswordLabel: 'Nuova password',
    newPasswordPlaceholder: 'Inserisci la nuova password',
    updateButton: 'Aggiorna password',
    updating: 'Aggiornamento in corso...',
    newPasswordRequired: 'Inserisci la nuova password',
    passwordLengthError: 'La password deve contenere almeno 6 caratteri',
    updateSuccess: 'Password aggiornata con successo',
    updateError: "Errore durante l'aggiornamento della password",
    recentLoginRequired:
      'Effettua il logout e il login per aggiornare la password',
    fetchError: "Errore durante il recupero dei dati dell'utente",
  },
  pilgrimSelector: {
    searchPlaceholder: 'Cerca per nome del pellegrino o numero passaporto...',
    passport: 'Passaporto',
    package: 'Pacchetto',
    noResults: 'Nessun pellegrino trovato',
    startSearch: 'Inizia a cercare un pellegrino...',
  },
  campBedModal: {
    tent: 'Tenda',
    hall: 'Sala',
    bed: 'Letto',
    noPermissionAssign: 'Non hai il permesso di assegnare pellegrini',
    noPermissionRemove: 'Non hai il permesso di rimuovere il pellegrino',
    noPermissionManage: 'Non hai il permesso di gestire questo letto',
    assignSuccess: 'Pellegrino assegnato con successo',
    assignError: "Errore durante l'assegnazione del pellegrino",
    removeSuccess: 'Assegnazione del pellegrino rimossa con successo',
    removeError: 'Errore durante la rimozione del pellegrino',
    removeButton: 'Rimuovi assegnazione',
    assignInstructions:
      'Seleziona un pellegrino da assegnare a questo letto. Assicurati che il pellegrino:',
    assignRule1: 'Non sia già assegnato altrove',
    assignRule2: 'Sia compatibile con il tipo di sala ({gender})',
    assignRule3: 'Sia collegato a una guida approvata',
    male: 'Uomini',
    female: 'Donne',
  },
  campDetails: {
    notFound: "Tabella dell'alloggio non trovata",
    stats: {
      totalTents: 'Totale tende',
      totalHalls: 'Totale sale',
      occupiedBeds: 'Letti occupati',
      occupancyRate: 'Tasso di occupazione',
    },
    filters: {
      searchPlaceholder: 'Cerca per numero tenda o nome pellegrino...',
      allGenders: 'Tutti i tipi',
      male: 'Uomini',
      female: 'Donne',
      allOccupancy: 'Tutti gli stati',
      occupied: 'Occupato',
      available: 'Disponibile',
    },
    tentHeader: 'Tenda',
    hallHeader: 'Sala',
    available: 'Disponibile',
  },
  room: {
    roomTypes: {
      double: 'Doppia',
      triple: 'Tripla',
      quadruple: 'Quadrupla',
    },
  },
  pilgrimsTable: {
    searchPlaceholder: 'Cerca per nome o ID piattaforma Nusk...',
    exportButton: 'Esporta Excel',
    activeFilters: 'Filtri attivi',
    filters: {
      allGenders: 'Tutti i tipi',
      male: 'Maschio',
      female: 'Femmina',
      allRoomTypes: 'Tutti i tipi di stanza',
      double: 'Doppia',
      triple: 'Tripla',
      quadruple: 'Quadrupla',
      search: 'Cerca',
      gender: 'Tipo',
      roomType: 'Tipo di stanza',
    },
    tableHeaders: {
      pilgrim: 'Pellegrino',
      packageInfo: 'Informazioni sul pacchetto',
      flightInfo: 'Informazioni sul volo',
      accommodation: 'Alloggio',
      contact: 'Contatto',
      passport: 'Passaporto',
      serialNumber: 'ID piattaforma Nusk',
      pnr: 'PNR',
      ticket: 'Biglietto',
      mainMakkahRoom: 'Stanza principale a Mecca',
      shiftingMakkahRoom: 'Stanza di transizione a Mecca',
      madinahRoom: 'Stanza a Medina',
      residence: 'Residenza',
      nationality: 'Nazionalità',
    },
    pagination: {
      page: 'Pagina',
      of: 'di',
      pilgrims: 'pellegrini',
    },
  },
  roomDetailsModal: {
    room: 'Stanza',
    roomInfo: 'Informazioni sulla stanza',
    occupancy: 'Occupazione',
    pilgrims: 'Pellegrini',
    bed: 'Letto',
    guide: 'Guida',
    noPilgrims: 'Nessun pellegrino in questa stanza',
    roomTypes: {
      double: 'Doppia',
      triple: 'Tripla',
      quadruple: 'Quadrupla',
    },
  },
  landing: {
    hero: {
      title: 'Sistema di gestione integrato per Hajj e Umrah',
      subtitle: 'Completo',
      description:
        'Organizza le tue operazioni in modo efficiente con la nostra piattaforma integrata per la gestione di alloggi, trasporti e servizi per i pellegrini',
      cta: 'Accedi al sistema',
    },
    features: {
      title: 'Caratteristiche principali',
      accommodation: {
        title: 'Gestione alloggi',
        description:
          'Gestisci gli alloggi dei pellegrini in modo efficiente con il sistema di housing avanzato',
      },
      movement: {
        title: 'Coordinamento degli spostamenti',
        description:
          'Traccia e coordina i movimenti dei pellegrini in tempo reale',
      },
      camp: {
        title: 'Gestione dei campi',
        description:
          'Strumenti completi per la gestione dei campi e delle strutture per i pellegrini',
      },
      services: {
        title: 'Servizi per i pellegrini',
        description:
          'Fornisci servizi senza intoppi per soddisfare tutte le esigenze dei pellegrini',
      },
    },
    benefits: {
      title: 'Vantaggi del sistema',
      satisfaction: 'Soddisfazione del cliente',
      pilgrims: 'Pellegrini',
      support: 'Supporto continuo',
      features: 'Funzionalità integrate',
    },
    systemFeatures: {
      title: 'Funzionalità integrate del sistema',
      hotel: {
        title: 'Gestione hotel',
        description:
          "Gestione visiva e interattiva delle camere e dell'occupazione",
      },
      flight: {
        title: 'Gestione voli',
        description:
          'Coordinamento delle prenotazioni aeree e gestione degli orari',
      },
      task: {
        title: 'Monitoraggio delle attività',
        description:
          'Gestione completa delle attività e monitoraggio dei progressi',
      },
      guide: {
        title: 'Assegnazione guide',
        description:
          "Sistema efficiente per l'assegnazione e la gestione delle guide",
      },
    },
    finalCta: {
      title: 'Sei pronto a iniziare?',
      description:
        'Accedi al pannello di controllo per gestire alloggi, movimenti e servizi per i pellegrini',
      cta: 'Accedi al sistema',
    },
    stats: {
      totalCamps: 'Totale campi',
      occupiedTents: 'Tende occupate',
      totalCapacity: 'Capacità totale',
      occupancyRate: 'Tasso di occupazione',
      pilgrims: 'Pellegrini',
      camps: 'Campi',
      capacity: 'Capacità',
      rate: 'Tasso',
    },
    systemBenefits: {
      title: 'Vantaggi del sistema',
      efficiency: {
        title: 'Alta efficienza',
        description: 'Gestione fluida ed efficiente di tutte le operazioni',
      },
      realTime: {
        title: 'Aggiornamenti in tempo reale',
        description: 'Monitoraggio dei dati e dei movimenti in tempo reale',
      },
      integration: {
        title: 'Integrazione completa',
        description: 'Sistema integrato che collega tutti i servizi',
      },
      support: {
        title: 'Supporto tecnico continuo',
        description: 'Team di supporto disponibile 24/7',
      },
    },
    mainFeatures: {
      title: 'Caratteristiche principali',
      accommodation: {
        title: 'Gestione alloggi',
        description: 'Gestione efficiente degli alloggi per i pellegrini',
      },
      transportation: {
        title: 'Gestione trasporti',
        description:
          'Organizzazione degli spostamenti dei pellegrini tra i siti sacri',
      },
      tasks: {
        title: 'Gestione attività',
        description:
          'Monitoraggio e gestione delle attività dei pellegrini e dei team',
      },
      guides: {
        title: 'Gestione guide',
        description: 'Assegnazione e monitoraggio delle guide per i pellegrini',
      },
    },
  },
  auth: {
    loginTitle: 'Accedi',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Password dimenticata?',
    login: 'Accedi',
    loggingIn: 'Accesso in corso...',
    loginSuccess: 'Accesso riuscito',
    loginError: 'Accesso fallito. Si prega di verificare email e password.',
    resetPassword: 'Reimposta password',
    resetInstructions: 'Inserisci il tuo indirizzo email e ti invieremo le istruzioni per reimpostare la password.',
    emailRequired: 'Email obbligatoria',
    resetSuccess: 'Email di reimpostazione inviata. Controlla la tua casella di posta.',
    resetError: 'Invio email di reimpostazione fallito. Riprova.',
    cancel: 'Annulla',
    sendResetLink: 'Invia link di reimpostazione',
    sending: 'Invio in corso...',
    collaborationMessage: 'Alimentato dalla nostra partnership per l\'eccellenza',
    collaborationSubtext: 'Portare innovazione ai servizi Hajj',
    ithraaLogoAlt: 'Ithraa Al Khair',
    rehabLogoAlt: 'Azienda Rehab',
    copyright: '© 2025 Tutti i diritti riservati a Rehab Company',
    poweredBy: 'Sistema sviluppato da Rehab Company'
  },
  authh: {
    logout: 'Esci',
  },
  components: {
    header: {
      userInfo: {
        organizerName: 'Nome organizzatore',
        gender: {
          male: 'Maschio',
          female: 'Femmina',
        },
      },
      logout: 'Esci',
    },
  },
  dashboard: {
    title: 'Dashboard',
    stats: {
      totalMembers: 'Totale membri',
      activeMembers: 'Membri attivi',
      suspendedMembers: 'Membri sospesi',
    },
    recentActivity: {
      title: 'Attività recenti',
      types: {
        login: 'Accesso',
        update: 'Aggiornamento dati',
        create: 'Aggiunta nuovo membro',
      },
    },
  },
  team: {
    title: 'Team',
    addMember: 'Aggiungi nuovo membro',
    search: {
      placeholder: 'Cerca per nome utente o email...',
      filters: {
        title: 'Filtri attivi',
        allRoles: 'Tutti i ruoli',
        allGenders: 'Tutti i tipi',
        allStatuses: 'Tutti gli stati',
        male: 'Maschio',
        female: 'Femmina',
        active: 'Attivo',
        suspended: 'Sospeso',
        clearFilters: 'Cancella filtri',
      },
    },
    noResults: 'Nessun utente corrisponde ai filtri selezionati',
    form: {
      title: {
        add: 'Aggiungi nuovo membro',
        edit: 'Modifica dati membro',
        selectRole: 'Seleziona ruolo',
      },
      fields: {
        name: 'Nome',
        email: 'Email',
        password: 'Password',
        gender: 'Genere',
        role: 'Ruolo',
        status: 'Stato',
      },
      buttons: {
        save: 'Salva',
        saving: 'Salvataggio in corso...',
        cancel: 'Annulla',
      },
      validation: {
        required: 'Questo campo è obbligatorio',
        emailInvalid: 'Email non valida',
        passwordLength: 'La password deve contenere almeno 6 caratteri',
      },
    },
    delete: {
      title: 'Elimina membro',
      message:
        'Sei sicuro di voler eliminare il membro "{name}"? Questa azione non può essere annullata.',
      confirm: 'Elimina',
      cancel: 'Annulla',
    },
    messages: {
      addSuccess: 'Membro aggiunto con successo',
      addError: "Errore durante l'aggiunta del membro",
      updateSuccess: 'Dati membro aggiornati con successo',
      updateError: "Errore durante l'aggiornamento dei dati del membro",
      deleteSuccess: 'Membro eliminato con successo',
      deleteError: "Errore durante l'eliminazione del membro",
    },
  },
  roles: {
    title: 'Ruoli e permessi',
    addRole: 'Aggiungi nuovo ruolo',
    labels: {
      admin: 'Amministratore di sistema',
      guide: 'Guida',
      organizer: 'Organizzatore',
    },
    form: {
      title: {
        add: 'Aggiungi nuovo ruolo',
        edit: 'Modifica ruolo',
      },
      fields: {
        name: 'Nome del ruolo',
        permissions: 'Permessi',
      },
      sections: {
        dashboard: 'Dashboard',
        team: 'Team',
        roles: 'Ruoli e permessi',
      },
      validation: {
        required: 'Questo campo è obbligatorio',
        selectPermissions: 'Seleziona almeno un permesso',
      },
      buttons: {
        save: 'Salva',
        saving: 'Salvataggio in corso...',
        cancel: 'Annulla',
      },
    },
    permissions: {
      title: 'Permessi',
      create: 'Crea',
      read: 'Leggi',
      update: 'Modifica',
      delete: 'Elimina',
    },
    actions: {
      edit: 'Modifica',
      delete: 'Elimina',
    },
    delete: {
      title: 'Elimina ruolo',
      message:
        'Sei sicuro di voler eliminare il ruolo "{name}"? Questa azione non può essere annullata.',
      confirm: 'Elimina',
      cancel: 'Annulla',
    },
    messages: {
      addSuccess: 'Ruolo aggiunto con successo',
      addError: "Errore durante l'aggiunta del ruolo",
      updateSuccess: 'Ruolo aggiornato con successo',
      updateError: "Errore durante l'aggiornamento del ruolo",
      deleteSuccess: 'Ruolo eliminato con successo',
      deleteError: "Errore durante l'eliminazione del ruolo",
    },
  },
  organizers: {
    title: 'Organizzatori',
    addOrganizer: 'Aggiungi nuovo organizzatore',
    form: {
      title: {
        add: 'Aggiungi nuovo organizzatore',
        edit: 'Modifica dati organizzatore',
      },
      fields: {
        name: 'Nome',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Conferma password',
      },
      validation: {
        required: 'Questo campo è obbligatorio',
        emailInvalid: 'Email non valida',
        passwordLength: 'La password deve contenere almeno 6 caratteri',
        passwordsNotMatch: 'Le password non coincidono',
      },
      buttons: {
        save: 'Salva',
        saving: 'Salvataggio in corso...',
        cancel: 'Annulla',
      },
    },
    table: {
      name: 'Organizzatore',
      email: 'Email',
      password: 'Password',
      actions: 'Azioni',
    },
    actions: {
      edit: 'Modifica',
      delete: 'Elimina',
      resetPassword: 'Cambia password',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password',
      copyEmail: 'Copia email',
      copyPassword: 'Copia password',
    },
    messages: {
      addSuccess: 'Organizzatore aggiunto con successo',
      addError: "Errore durante l'aggiunta dell'organizzatore",
      updateSuccess: 'Dati organizzatore aggiornati con successo',
      updateError: "Errore durante l'aggiornamento dei dati dell'organizzatore",
      deleteSuccess: 'Organizzatore eliminato con successo',
      deleteError: "Errore durante l'eliminazione dell'organizzatore",
      resetSuccess: 'Password cambiata con successo',
      resetError: 'Errore durante il cambio della password',
      copySuccess: 'Copiato con successo',
      copyError: 'Errore durante la copia',
    },
    delete: {
      title: 'Elimina organizzatore',
      message:
        'Sei sicuro di voler eliminare l\'organizzatore "{name}"? Questa azione non può essere annullata.',
      confirm: 'Elimina',
      cancel: 'Annulla',
    },
    resetPassword: {
      title: 'Cambia password',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma password',
    },
  },
  management: {
    title: 'Gestione',
  },
  menu: {
    dashboard: 'Dashboard',
    pilgrims: 'Pellegrini',
    packages: 'Pacchetti',
    flights: 'Voli',
    verification: 'Verifica',
    pilgrimGuide: 'Collega pellegrini',
    linkingStatus: 'Stato del collegamento',
    disputes: 'Dispute',
    accommodationTasks: 'Compiti di alloggio',
    accommodation: 'Alloggio',
    hotelVisualization: 'Visualizzazione hotel',
    team: 'Team',
    roles: 'Ruoli e permessi',
    organizers: 'Organizzatori',
    guides: 'Guide',
    movements: 'Pianificazione movimenti',
    campAccommodation: 'Alloggio nei campi',
    accommodationLogs: 'Registro degli Alloggi',
    settings: 'Impostazioni',
    bans: 'Gestione dei divieti',
    pilgrimOwnership: 'Proprietà dei Pellegrini',
    organizerFinance: 'Finanza degli Organizzatori',
    verificationWizard: 'Contratto Guida/Organizzatore',
    verificationApproval: 'Contratti Organizzatori/Guide',
  },
  menuGroups: {
    dashboard: 'Dashboard',
    management: 'Gestione dati',
    linking: 'Collegamento',
    accommodation: 'Alloggio',
    settings: 'Impostazioni',
  },
  pilgrimGuide: {
    header: 'Collega pellegrini alle guide',
    guideDescription: 'Aggiungi pellegrini alla tua lista di supervisione.',
    adminDescription:
      'Collega pellegrini alle guide appropriate e gestisci la relazione tra loro.',
    addButton: 'Aggiungi pellegrino',
    linkButton: 'Collega pellegrino a guida',
  },
  pilgrimGuideDetails: {
    header: {
      basicInfo: 'Informazioni di base',
      contactInfo: 'Informazioni di contatto',
      locationInfo: "Informazioni sull'alloggio",
      hotelInfo: 'Informazioni sugli hotel',
      mainMakkahHotel: 'Hotel principale a Mecca',
      shiftingMakkahHotel: 'Hotel di transizione a Mecca',
      madinahHotel: 'Hotel a Medina',
    },
    labels: {
      name: 'Nome',
      passport: 'Numero passaporto',
      gender: {
        male: 'Maschio',
        female: 'Femmina',
      },
      age: 'Età',
      mobile: 'Numero di telefono',
      email: 'Email',
      residenceCountry: 'Paese di residenza',
      nationality: 'Nazionalità',
      hotelName: 'Nome hotel',
      roomType: 'Tipo di stanza',
      roomNumber: 'Numero stanza',
      years: 'Anni',
    },
  },
  statusBadge: {
    statuses: {
      approved: 'Collegato',
      disputed: 'In disputa',
      rejected: 'Rifiutato',
      pending: 'In attesa',
      waitingIdentification: 'In attesa di identificazione',
    },
    actions: {
      viewEvidence: 'Visualizza prova',
      editEvidence: 'Modifica',
      submitEvidence: 'Presenta prova',
    },
  },
  linkingTable: {
    filters: {
      searchPlaceholder: 'Cerca per nome pellegrino o numero passaporto...',
      allStatuses: 'Tutti gli stati',
      approved: 'Collegato',
      pending: 'In attesa',
      rejected: 'Rifiutato',
      waitingIdentification: 'In attesa di identificazione',
      allCountries: 'Tutti i paesi',
      activeFilters: 'Filtri attivi',
      search: 'Cerca',
      status: 'Stato',
      country: 'Paese',
    },
    tableHeaders: {
      pilgrim: 'Informazioni pellegrino',
      package: 'Pacchetto',
      guideAndOrganizer: 'Guida e organizzatore',
      status: 'Stato',
    },
    pagination: {
      page: 'Pagina',
      of: 'di',
      pilgrimsCount: 'pellegrini',
    },
  },
  packageInfo: {
    pilgrimType: 'Tipo di pellegrino',
    nusukGroup: 'Gruppo Nusuk',
  },
  pilgrimGuideTable: {
    headers: {
      pilgrimInfo: 'Informazioni pellegrino', // Translation for "Pilgrim Info"
      package: 'Pacchetto', // Translation for "Package"
      guideAndOrganizer: 'Guida e organizzatore', // Translation for "Guide & Organizer"
      status: 'Stato', // Translation for "Status"
    },
    pagination: {
      page: 'Pagina', // Translation for "Page"
      of: 'di', // Translation for "of"
      pilgrimCount: 'pellegrini', // Translation for "pilgrims"
    },
  },
  pilgrimInfo: {
    passport: 'Passaporto',
  },
  filters: {
    searchPlaceholder: 'Cerca per nome pellegrino, numero passaporto o PNR...',
    allGenders: 'Tutti i tipi',
    allCountries: 'Tutti i paesi', // Translation for "All Countries"
    male: 'Maschio',
    female: 'Femmina',
    allNationalities: 'Tutte le nazionalità',
    unitedKingdom: 'Regno Unito',
    malaysia: 'Malesia',
    indonesia: 'Indonesia',
    allPackages: 'Tutti i tipi di pacchetti',
    mainPackage: 'Principale',
    shiftingPackage: 'Mobile',
    allHotels: 'Tutti gli hotel',
    vocoHotel: 'Hotel Voco',
    hiltonHotel: 'Hotel Hilton',
    marriottHotel: 'Hotel Marriott',
    allStatuses: 'Tutti gli stati',
    approved: 'Approvato',
    pending: 'In attesa',
    rejected: 'Rifiutato',
    activeFilters: 'Filtri attivi',
    search: 'Cerca',
    gender: 'Genere',
    nationality: 'Nazionalità',
    packageType: 'Tipo di pacchetto',
    hotel: 'Hotel',
    status: 'Stato',
    clearFilters: 'Cancella filtri',
  },
  statusFilter: {
    allStatuses: 'Tutti gli stati', // All Statuses
    approved: 'Collegato', // Approved
    pending: 'In attesa', // Pending
    rejected: 'Rifiutato', // Rejected
    disputed: 'In disputa', // Disputed
    waitingIdentification: 'In attesa di identificazione',
  },
  searchInput: {
    placeholder: 'Cerca per nome pellegrino o numero passaporto...', // Search by pilgrim name or passport number
  },
  statistics: {
    rooms: 'Camere', // Rooms
    occupiedTotal: 'Occupate / Totali', // Occupied / Total
    beds: 'Letti', // Beds
    occupiedCapacity: 'Occupati / Capacità', // Occupied / Capacity
    occupancyRate: 'Tasso di occupazione', // Occupancy Rate
    percentage: 'Percentuale', // Percentage
  },
  actions: {
    viewDetails: 'Visualizza dettagli', // View Details
    download: 'Scarica alloggio', // Download Accommodation
    deleteTable: 'Elimina tabella', // Delete Table
  },
  messages: {
    exportSuccess: 'Dati di alloggio esportati con successo', // Accommodation data exported successfully
    exportError: "Errore durante l'esportazione dei dati di alloggio", // Failed to export accommodation data
    deleteSuccess: 'Tabella di alloggio eliminata con successo', // Accommodation table deleted successfully
    deleteError: "Errore durante l'eliminazione della tabella di alloggio", // Failed to delete accommodation table
  },
  confirmDialog: {
    deleteTitle: 'Elimina tabella di alloggio', // Delete Accommodation Table
    deleteMessage: 'Sei sicuro di voler eliminare la tabella "{name}"?', // Are you sure you want to delete the table "{name}"?
    delete: 'Elimina', // Delete
    cancel: 'Annulla', // Cancel
  },
  roomStats: {
    rooms: 'Statistiche delle camere', // Room Statistics
    occupiedTotal: 'Occupate / Totali', // Occupied / Total
    beds: 'Statistiche dei letti', // Bed Statistics
    occupiedCapacity: 'Occupati / Capacità', // Occupied / Capacity
    guestDistribution: 'Distribuzione degli ospiti', // Guest Distribution
    male: 'Maschi', // Male
    female: 'Femmine', // Female
    occupancyRate: 'Tasso di occupazione', // Occupancy Rate
    highOccupancy: 'Occupazione alta', // High Occupancy
    mediumOccupancy: 'Occupazione media', // Medium Occupancy
    lowOccupancy: 'Occupazione bassa', // Low Occupancy
  },
  roomTable: {
    headers: {
      roomNumber: 'Numero della stanza',
      roomType: 'Tipo di stanza',
      capacity: 'Capacità',
      occupancy: 'Occupazione',
      actions: 'Visualizza',
    },
    roomTypes: {
      double: 'Doppia',
      triple: 'Tripla',
      quad: 'Quadrupla',
    },
  },
  roomTableRow: {
    roomTypes: {
      double: 'Camera doppia',
      triple: 'Camera tripla',
      quadruple: 'Camera quadrupla',
    },
    capacity: 'Capacità',
    statuses: {
      available: 'Disponibile',
      full: 'Completo',
      partial: 'Parzialmente disponibile',
      availableBed: 'Letto disponibile',
    },
    years: 'Anni',
    actions: {
      viewDetails: 'Visualizza dettagli',
    },
  },
  errors: {
    loadRoom: 'Errore durante il caricamento dei dettagli della camera',
    assignPermission: 'Non hai il permesso di assegnare pellegrini',
    removePermission: 'Non hai il permesso di rimuovere pellegrini',
    invalidRoomNumber: 'Inserisci un numero di camera valido',
    assignFailed: "Errore durante l'assegnazione del pellegrino",
    removeFailed: 'Errore durante la rimozione del pellegrino',
    updateRoomNumber: "Errore durante l'aggiornamento del numero della camera",
    emptyComment: 'Inserisci il testo del commento',
    notLoggedIn: "Devi effettuare l'accesso per aggiungere un commento",
    addComment: "Errore durante l'aggiunta del commento",
    deleteComment: "Errore durante l'eliminazione del commento",
  },
  success: {
    assignPilgrim: 'Pellegrino assegnato con successo',
    removePilgrim: 'Pellegrino rimosso con successo',
    updateRoomNumber: 'Numero della camera aggiornato con successo',
    addComment: 'Commento aggiunto con successo',
    deleteComment: 'Commento eliminato con successo',
  },
  roomViewModal: {
    title: 'Camera',
    editTitle: 'Modifica numero camera',
    placeholder: 'Inserisci il nuovo numero della camera',
    roomType: 'Tipo di camera',
    double: 'Doppia',
    triple: 'Tripla',
    quadruple: 'Quadrupla',
    bedsCount: 'Numero di letti',
    assignNew: 'Assegna nuovo pellegrino',
  },
  pilgrimCard: {
    bed: 'Letto',
    years: 'Anni',
    checkIn: 'Data di arrivo',
    checkOut: 'Data di partenza',
    remove: 'Rimuovi assegnazione',
    assignNew: 'Assegna nuovo pellegrino',
    guide: 'Guida',
  },
  commentSection: {
    header: 'Commenti e note',
    delete: 'Elimina commento',
    placeholder: 'Scrivi un commento...',
  },
  roomFilters: {
    placeholders: {
      search: 'Cerca per numero camera...',
    },
    options: {
      allRoomTypes: 'Tutti i tipi di camera',
      double: 'Doppia',
      triple: 'Tripla',
      quadruple: 'Quadrupla',
      allStatuses: 'Tutti gli stati',
      occupied: 'Occupata',
      available: 'Disponibile',
      partial: 'Parzialmente occupata',
    },
    activeFilters: 'Filtri attivi',
    labels: {
      search: 'Cerca',
      roomType: 'Tipo di camera',
      status: 'Stato',
    },
  },
  accommodationTasks: {
    header: 'Compiti di alloggio',
    subheader:
      'Monitoraggio dello stato degli alloggi dei pellegrini negli hotel',
    stats: {
      totalPilgrims: 'Totale pellegrini',
      accommodated: 'Alloggiati',
      pending: 'In attesa',
      completionRate: 'Tasso di completamento',
    },
    filters: {
      title: 'Opzioni di filtro',
    },
    noResults: 'Nessun pellegrino corrisponde ai filtri selezionati',
  },
  tasksFilters: {
    searchPlaceholder: 'Cerca per nome pellegrino o paese...',
    gender: {
      all: 'Tutti i tipi',
      male: 'Maschio',
      female: 'Femmina',
    },
    status: {
      all: 'Tutti gli stati',
      completed: 'Alloggiato',
      pending: 'In attesa',
    },
    activeFilters: 'Filtri attivi:',
    labels: {
      search: 'Cerca',
      gender: 'Genere',
      status: 'Stato',
    },
  },
  accommodationTasksList: {
    headers: {
      pilgrim: 'Pellegrino',
      package: 'Pacchetto',
      mainMakkah: 'Hotel principale a Mecca',
      shiftingMakkah: 'Hotel di transizione a Mecca',
      madinah: 'Hotel a Medina',
    },
    room: 'Camera',
  },
  common: {
    notSpecified: 'Non specificato',
    notAvailable: 'Non disponibile',
    pilgrims: 'Pellegrini',
    delete: 'Elimina',
    cancel: 'Annulla',
    loading: 'Caricamento in corso...',
    error: 'Si è verificato un errore durante il caricamento',
  },
  pagination: {
    page: 'Pagina',
    of: 'di',
  },
  recentPilgrims: {
    title: 'Ultimi pellegrini aggiunti',
    statuses: {
      approved: 'Collegato',
      disputed: 'In disputa',
      pending: 'In attesa',
    },
  },
  organizerStats: {
    totalGuides: 'Guide',
    totalPilgrims: 'Totale pellegrini',
    pendingLinks: 'Richieste di collegamento',
    disputes: 'Dispute',
  },
  guidesPage: {
    title: 'Guide',
    organizerDescription: 'Gestisci le guide sotto la tua responsabilità',
    adminDescription: 'Gestisci tutte le guide nel sistema',
  },
  guidesList: {
    title: 'Guide',
    addButton: 'Aggiungi guida',
    resetPassword: 'Cambia password',
    deleteTitle: 'Elimina guida',
    deleteMessage: 'Sei sicuro di voler eliminare la guida "{name}"?',
    noGuides: 'Nessuna guida al momento',
  },
  pilgrimGuideList: {
    noPilgrims: 'Nessun pellegrino collegato al momento',
  },
  addGuideModal: {
    title: 'Aggiungi nuova guida',
    requiredFields: 'Tutti i campi sono obbligatori',
    successMessage: 'Guida aggiunta con successo',
    errorMessage: "Si è verificato un errore durante l'aggiunta della guida",
    toastError: "Errore durante l'aggiunta della guida",
  },
  guideForm: {
    labels: {
      name: 'Nome',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Conferma password',
    },
    errors: {
      name: 'Questo campo è obbligatorio',
      emailRequired: 'Questo campo è obbligatorio',
      invalidEmail: 'Email non valida',
      passwordRequired: 'Questo campo è obbligatorio',
      passwordLength: 'La password deve contenere almeno 6 caratteri',
      passwordMismatch: 'Le password non coincidono',
    },
    submit: 'Salva',
    loading: 'Salvataggio in corso...',
  },
  addPilgrimModal: {
    titleGuide: 'Aggiungi pellegrino',
    titleAdminOrganizer: 'Collega pellegrino a guida',
    passportError: 'Inserisci il numero del passaporto',
    guideError: 'Seleziona una guida',
    pilgrimNotFound: 'Nessun pellegrino trovato con questo numero',
    guideNotFound: 'Guida non trovata',
    unauthorized: 'Operazione non autorizzata',
    success: 'Pellegrino aggiunto con successo',
    waitingIdentificationSuccess: 'Pellegrino aggiunto e in attesa di identificazione',
    addButton: 'Aggiungi',
    addingButton: 'Aggiunta in corso...',
    cancelButton: 'Annulla',
  },
  pilgrimAssignment: {
    errorNoPassport: 'Inserisci il numero del passaporto',
    errorAssign: "Errore durante l'assegnazione del pellegrino",
    placeholder: 'Inserisci il numero del passaporto',
    submitLoading: 'Verifica in corso...',
    submit: 'Assegna pellegrino',
  },
  passportInput: {
    label: 'Numero passaporto',
    requiredMark: '*',
    placeholder: 'Inserisci il numero del passaporto',
    loading: 'Caricamento in corso...',
  },
  guideSearch: {
    label: 'Guida',
    requiredMark: '*',
    placeholder: 'Cerca per nome guida o email...',
    noGuidesFound: 'Nessuna guida disponibile',
    noMatchingGuides: 'Nessuna guida corrisponde alla ricerca',
  },
  hotelVisualizationPage: {
    headerTitle: 'Visualizzazione hotel',
    headerSubtitle: 'Visualizza dettagli di hotel, edifici e camere',
    hotelSelectionTitle: 'Seleziona hotel',
    buildingSelectionTitle: 'Seleziona edificio',
  },
  buildingView: {
    floorNavigationTitle: 'Piani',
    floorNavigationSubtitle: 'Seleziona un piano per visualizzarne i dettagli',
  },
  hotelFloor: {
    floorLabel: 'Piano',
  },
  hotelSelector: {
    singleBuilding: 'Un edificio',
    multipleBuildings: '{count} edifici',
  },
  guideStats: {
    registeredPilgrims: 'Pellegrini registrati',
    accommodatedPilgrims: 'Alloggiati',
    pendingPilgrims: 'In attesa',
    disputes: 'Dispute',
  },
  bedList: {
    available: "Disponibile per l'assegnazione!",
    bed: 'Letto',
    assign: 'Assegna pellegrino',
  },
};
